/**
 *
 * Title
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ title }) => <title>{title || 'GAConnector'}</title>;

Title.propTypes = {
  title: PropTypes.string,
};

export default Title;
